import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { decodeFolderParam, encodeFolderParam } from 'helper/products/fileExplorer';

export const FOLDER_PARAM = 'pasta';

/**
 * Pasta aberta no "Meus Arquivos", guardada na URL (`?pasta=-PREVS/diario`): o link pode ser
 * compartilhado, sobrevive ao F5 e o "voltar" do navegador volta de pasta.
 */
export default function useFolderPath() {
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get(FOLDER_PARAM);
  const path = useMemo(() => decodeFolderParam(param), [param]);

  const openFolder = useCallback((next: string[], options: { replace?: boolean } = {}) => {
    setSearchParams((current) => {
      const params = new URLSearchParams(current);
      if (next.length) params.set(FOLDER_PARAM, encodeFolderParam(next));
      else params.delete(FOLDER_PARAM);
      return params;
    }, { replace: options.replace });
  }, [setSearchParams]);

  return { path, openFolder };
}
